import i18next from 'i18next';

export const getActions = (
  selectedProductIds,
  openProductTimeSlotsAllocationPanel,
  handleXLSExport,
  selectedRowsSize,
  canEditAllocation,
  canDuplicateStoreTimeslots,
  handleTimeSlotsSetup,
  hasTimeSlots,
) => {
  const actions = [
    {
      label: i18next.t(selectedRowsSize > 0 ? 'GENERAL.EXPORT_SELECTION' : 'GENERAL.EXPORT_LIST'),
      icon: `/images/inpulse/file-download-black-small.svg`,
      handleClick: handleXLSExport,
    },
  ];

  if (hasTimeSlots && canDuplicateStoreTimeslots) {
    actions.unshift({
      label: i18next.t('ADMIN.STORES.TIME_SLOTS_DUPLICATE_FROM_CLONE'),
      icon: ({ isKitchen }) =>
        isKitchen ? '/images/inpulse/settings-lgrey.svg' : '/images/inpulse/settings.svg',
      handleClick: handleTimeSlotsSetup,
    });
  }

  if (selectedProductIds.length && canEditAllocation) {
    actions.unshift({
      label: i18next.t('ADMIN.STORES.TIME_SLOTS_ALLOCATIONS_UPDATE_ACTION'),
      icon: `/images/inpulse/pen-ip-black-small.svg`,
      handleClick: openProductTimeSlotsAllocationPanel,
    });
  }

  return actions;
};
